import type {
  Dossier,
  ReservationResponse,
} from '@owl-frontend/api-client/interface';
import { AsyncActionState, setupSlice } from '@owl-frontend/redux';

export interface DossiersState {
  items: Dossier[];
  lastCursor: string | null;
  reservedDossier?: {
    reservedDossierId?: string;
    peekedById?: string;
    recordId?: string;
    groupId?: string;
  };
  priorityDossierId?: string;
  priorityDossierGroupId?: string;
  peekShouldStartReview?: boolean;
  reservationStatus: {
    [k: string]: ReservationResponse;
  };
  // legacy state
  accepted: {
    items: Dossier[];
    lastCursor: string | null;
  };
  dismissed: {
    items: Dossier[];
    lastCursor: string | null;
  };
  undecided: {
    items: Dossier[];
    lastCursor: string | null;
  };
  closed: {
    items: Dossier[];
    lastCursor: string | null;
  };
  count: {
    accepted: number;
    dismissed: number;
    undecided: number;
    closed: number;
  };
  // end
  actions: {
    dossiersListAll: AsyncActionState<import('./logic').DossiersListAllPayload>;
    dossiersListByStatus: AsyncActionState<
      | import('./logic').DossiersListPayload
      | import('./logic').DossiersListAllPayload
    >;
    peekReservation: AsyncActionState<ReservationResponse>;
    startReview: AsyncActionState;
    startReviewById: AsyncActionState;
    uploadFile: AsyncActionState;
    uploadFileReinvestigation: AsyncActionState;
    downloadDossiers: AsyncActionState<{ numDownloaded: number }>;
    // legacy
    dossiersPendingList: AsyncActionState<
      import('./logic').DossiersListPayload
    >;
    dossiersList: AsyncActionState<import('./logic').DossiersListPayload>;
    dossiersCount: AsyncActionState;
    // end
  };
}

const initialState: DossiersState = {
  items: [],
  lastCursor: null,
  accepted: {
    items: [],
    lastCursor: null,
  },
  dismissed: {
    items: [],
    lastCursor: null,
  },
  closed: {
    items: [],
    lastCursor: null,
  },
  undecided: {
    items: [],
    lastCursor: null,
  },
  count: {
    accepted: 0,
    dismissed: 0,
    undecided: 0,
    closed: 0,
  },
  reservationStatus: {},
  actions: {
    dossiersListAll: { status: 'uninitialized' },
    dossiersListByStatus: { status: 'uninitialized' },
    peekReservation: { status: 'uninitialized' },
    startReview: { status: 'uninitialized' },
    startReviewById: { status: 'uninitialized' },
    uploadFile: { status: 'uninitialized' },
    uploadFileReinvestigation: { status: 'uninitialized' },
    downloadDossiers: { status: 'uninitialized' },
    dossiersPendingList: { status: 'uninitialized' },
    dossiersList: { status: 'uninitialized' },
    dossiersCount: { status: 'uninitialized' },
  },
};

const dossiersSlice = setupSlice('dossiers', initialState);
export default dossiersSlice;
